export default __webpack_public_path__ + "static/media/message-sms-icon.12d705a6.svg";